import styled from 'styled-components'

export const Wrapper = styled.div<{ textAlignment: string }>`
  padding: 0 15px;
  max-width: 950px;
  margin: 0 auto;
  text-align: ${props => props.textAlignment};

  * {
    text-align: ${props => props.textAlignment};
  }

  h1,
  h2,
  h3 {
    ${props => props.theme.css.heading1};
    font-weight: ${props => props.theme.font.alt.bold};
  }

  h1 {
    font-size: 32px;
    margin: 0 0 2em;
  }

  h2 {
    margin: 0 0 1em;
  }

  h3 {
    margin: 0 0 1em;
  }

  h4 {
    ${props => props.theme.css.heading2};
    font-size: 20px;
    margin: 0 0 1em;
  }

  p {
    font-size: 16px;
    line-height: 1.5;
    margin: 0 0 1em;
  }
`
